module.exports = __webpack_public_path__ + "static/media/driver-celebrate.bc00eb46.png";